export interface TagIdResponseApi {
  tagId: string;
  tagName: string;
}

export let isTagIdResponseDTO = (
  variable: unknown
): variable is TagIdResponseApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "tagId" in variable &&
    typeof variable.tagId === "string"
  );
};
